import React from 'react'
import { Navigate } from 'react-router'
import privatePages from '../pages/App'
import publicPages from '../pages/Auth'

const { Dashboard, ProductList, ProductDetail, StaffAdd, Staff, OrderCart, OrderHistory, OrderHistoryItems,
    OrderReceived, OrderCancelled, TransferRequested, TransferRequestMoveOut, TransferRequestCancelled, InventoryReport,CustomerReport,InventoryMomentReport,BarcodeAuditTrail,
    Inventory, Transaction, GeneralAccount, ChangePassword, InventoryAudit, Brand, DailyActivityReport, GSTOutputReport, SalesReport, InventoryAdditionReport,
    InventoryDashboard, OrderDashboard, AccountsDashboard, SalesReturn, AddInventory, AddProduct, Setting, ApproveInventory, PendingInventory,
    AddBrand ,BulkUpload,Product,Barcode,ApproveBarcode,PriceUpdatedBarcode,SubAdmin,AddSubAdmin,Greeting,PendingProduct,LostBarcodeHistory, LostBarcode, 
    InternalRequest,InternalMoveOut,EComOrdersReport,CollectionReport,LensDetails,BulkInternalTransfer,SKU,InProcessOrder,OrderReady,SalesCart,BulkLostBarcode,
    Coupon,LensVariety,CreateCoupon,FeedbackForm,Role,AddRole,Warranty, MovementPending, MovementInProcess, MovementDelivered, MovementCancelled
} = privatePages
const { Login, Registration } = publicPages

const privateRoutes = [
    { path: "/", exact: true, component: <Navigate to="/dashboard" />, },
    { path: '/dashboard', component: <Dashboard /> },
    { path: '/inventory/detail', component: <InventoryDashboard /> },
    { path: '/order/detail', component: <OrderDashboard /> },
    { path: '/product/list', component: <ProductList /> },
    { path: '/accounts/gl', component: <AccountsDashboard /> },
    { path: '/product/details/:id', component: <ProductDetail /> },

    { path: '/lens-details', component: <LensDetails /> },
    
    { path: '/product', component: <Product /> },
    { path: '/pending-product', component: <PendingProduct /> },

    { path: '/staff', component: <Staff /> },
    { path: '/staff/add', component: <StaffAdd /> },
    { path: '/staff/edit/:id', component: <StaffAdd /> },
    { path: '/order-cart', component: <OrderCart /> },

    { path: '/procurement/order/history', component: <OrderHistory /> },
    { path: '/procurement/order/history/product-detail/:id', component: <OrderHistoryItems /> },
    { path: '/procurement/order/received', component: <OrderReceived /> },
    { path: '/procurement/cancelled', component: <OrderCancelled /> },

    { path: '/product/add', component: <AddProduct /> },
    { path: '/product/edit/:id', component: <AddProduct /> },
    { path: '/bulk-upload-product', component: <BulkUpload /> },


    { path: '/transfer-request/requested', component: <TransferRequested /> },
    { path: '/transfer-request/moved-out', component: <TransferRequestMoveOut /> },
    { path: '/transfer-request/cancelled', component: <TransferRequestCancelled /> },

    { path: '/internal-request/request', component: <InternalRequest /> },
    { path: '/internal-request/moved-out', component: <InternalMoveOut /> },
    { path: '/internal-request/bulk', component: <BulkInternalTransfer /> },

    

    { path: '/inventory/search', component: <Inventory /> },
    { path: '/inventory/add', component: <AddInventory /> },
    { path: '/inventory/edit/:id', component: <AddInventory /> },

    { path: '/inventory/approved', component: <ApproveInventory /> },
    { path: '/inventory/pending', component: <PendingInventory /> },

    { path: '/accounts/transaction', component: <Transaction /> },
    { path: '/accounts/general-account', component: <GeneralAccount /> },

    { path: '/report/inventory', component: <InventoryReport /> },
    { path: '/report/daily-activity', component: <DailyActivityReport /> },
    { path: '/report/gst', component: <GSTOutputReport /> },
    { path: '/report/sales', component: <SalesReport /> },
    { path: '/report/sales-return', component: <SalesReturn /> },
    { path: '/report/inventory-addition', component: <InventoryAdditionReport /> },
    { path: '/report/e-com-orders', component: <EComOrdersReport /> },
    { path: '/report/collection', component: <CollectionReport /> },
    { path: '/report/customer', component: <CustomerReport /> },
    { path: '/report/inventory-movement', component: <InventoryMomentReport /> },
    { path: '/report/barcode-audit-trail', component: <BarcodeAuditTrail /> },

    
    // for setting page
    { path: '/setting', component: <Setting /> },
    { path: '/settings/greeting', component: <Greeting /> },
    { path: '/sub-admin', component: <SubAdmin /> },
    { path: '/sub-admin/add', component: <AddSubAdmin /> },
    { path: '/sub-admin/edit/:id', component: <AddSubAdmin /> },

    { path: '/change-password', component: <ChangePassword /> },
    { path: '/brand', component: <Brand /> },
    { path: '/brand/add', component: <AddBrand /> },
    
    { path: '/pending-barcode', component: <Barcode /> },
    { path: '/approve-barcode', component: <ApproveBarcode /> },
    { path: '/bulk/lost-barcode', component:<BulkLostBarcode /> },
    { path: '/price-updated-barcode', component: <PriceUpdatedBarcode /> },
    { path: '/inventory/lost-barcode-history', component: <LostBarcodeHistory /> },
    { path: '/inventory/lost-barcode', component: <LostBarcode /> },

    { path: '/sku', component: <SKU /> },

    { path: '/fitting-lab/in-process', component: <InProcessOrder /> },
    { path: '/fitting-lab/order-ready', component: <OrderReady /> },

    { path: '/sales-cart/:id', component: <SalesCart /> },

    // for E-commerce Tab
    { path: '/e-commerce/coupon', component: <Coupon /> },
    { path: '/e-commerce/coupon/add', component: <CreateCoupon /> },
    { path: '/e-commerce/lens-variety', component: <LensVariety/> },

    // for feedback from
    { path: '/feedback', component: <FeedbackForm/> },

    //for roles
    { path: '/settings/role', component: <Role /> },
    { path: '/settings/role/add', component: <AddRole /> },
    { path: '/settings/role/edit/:id', component: <AddRole /> },

    //for warranty
    {path:"/warranty", component:<Warranty/>},

    // Movement Section
    {path:"/movement/pending", component:<MovementPending/>},
    {path:"/movement/in-process", component:<MovementInProcess/>},
    {path:"/movement/delivered", component:<MovementDelivered/>},
    {path:"/movement/cancelled", component:<MovementCancelled/>},
]

const PublicRoutes = [
    { path: '/login', component: <Login /> },
    { path: '/registration', component: <Registration /> },
]
export { privateRoutes, PublicRoutes }